/**
 * All frontend scripts that are related to Freestar ads should be included here.
 *
 * This is the file that Webpack is compiling into main-head-freestar.[hash].js
 */
require("./js/ads/admanager-freestar");
require("./js/ads/common");
